import { render, staticRenderFns } from "./PrintThermalReal.vue?vue&type=template&id=0bf1cf64&scoped=true"
import script from "./PrintThermalReal.vue?vue&type=script&lang=js"
export * from "./PrintThermalReal.vue?vue&type=script&lang=js"
import style0 from "./PrintThermalReal.vue?vue&type=style&index=0&id=0bf1cf64&prod&scoped=true&lang=css"
import style2 from "./PrintThermalReal.vue?vue&type=style&index=2&id=0bf1cf64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf1cf64",
  null
  
)

export default component.exports